export default "__VITE_ASSET__BxkA4U08__"